import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/400-italic.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/dm-sans/300.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import './styles/global.css';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
